function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.529,37.153c0-0.879-0.143-1.744-0.413-2.581l3.459-3.459l-4.583-4.583c0.959-0.84,1.537-2.062,1.537-3.377 c0-2.481-2.019-4.5-4.5-4.5c-0.182,0-0.362,0.018-0.54,0.04c0.022-0.178,0.04-0.357,0.04-0.54c0-2.481-2.019-4.5-4.5-4.5 c-0.182,0-0.362,0.018-0.54,0.04c0.022-0.178,0.04-0.357,0.04-0.54c0-2.481-2.019-4.5-4.5-4.5c-0.182,0-0.362,0.018-0.54,0.04 c0.022-0.178,0.04-0.357,0.04-0.54c0-2.481-2.019-4.5-4.5-4.5c-1.315,0-2.536,0.578-3.376,1.536L23.463,0L5.078,18.385l9.235,9.236 c-0.494,0.722-0.784,1.593-0.784,2.532c0,1.566,0.806,2.945,2.024,3.751c0.062,0.083,0.133,0.163,0.221,0.238l10.755,10.715v1.796 h-2v13h18h8v-13h-2v-3.029C50.442,42.003,51.529,39.672,51.529,37.153z M15.529,30.153c0-0.657,0.26-1.251,0.675-1.697l0.153-0.14 c0.348-0.318,0.766-0.528,1.207-0.616c0.151-0.029,0.305-0.047,0.464-0.047h2.201h7.799c1.378,0,2.5,1.121,2.5,2.5 s-1.122,2.5-2.5,2.5h-5.854h-4.146C16.65,32.653,15.529,31.532,15.529,30.153z M22.756,17.678c1.889-1.889,4.4-2.929,7.071-2.929 s5.182,1.04,7.071,2.929c1.889,1.889,2.929,4.4,2.929,7.071s-1.04,5.183-2.929,7.071c-1.883,1.884-4.391,2.921-7.061,2.921 c0,0,0,0,0,0c-0.504,0-1.01-0.042-1.508-0.118c1.725-0.116,3.192-1.189,3.841-2.709c-0.083,0.196-0.178,0.385-0.288,0.565 c1.352-0.354,2.59-1.061,3.603-2.073c1.511-1.511,2.343-3.521,2.343-5.657s-0.832-4.146-2.343-5.657s-3.52-2.343-5.657-2.343 s-4.146,0.832-5.657,2.343c-1.738,1.738-2.564,4.144-2.286,6.562h-2.008C19.604,22.708,20.637,19.797,22.756,17.678z M48.211,31.82 c-0.391,0.391-1.024,0.391-1.414,0c-0.391-0.391-0.391-1.024,0-1.414c0.391-0.391,1.024-0.391,1.414,0 C48.602,30.796,48.602,31.43,48.211,31.82z M45.383,33.234l0.707,0.707l-7.071,7.071l-0.707-0.707c-1.134-1.132-3.109-1.134-4.243,0 l-0.707,0.707l-3.536-3.536c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0l2.192,2.192c1.622-1.079,3.894-1.079,5.516,0 l4.384-4.385c-1.101-1.665-1.101-3.85,0-5.515l-2.192-2.192c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0l3.536,3.535 l-0.707,0.707C44.213,30.161,44.213,32.064,45.383,33.234z M35.483,43.134c-0.391-0.391-0.391-1.024,0-1.414 c0.391-0.391,1.024-0.391,1.414,0c0.391,0.391,0.391,1.024,0,1.414S35.874,43.524,35.483,43.134z M32.529,30.153 c0,0.278-0.034,0.548-0.082,0.812C32.495,30.701,32.529,30.431,32.529,30.153z M32.406,31.16c-0.055,0.241-0.126,0.476-0.218,0.701 C32.28,31.636,32.351,31.401,32.406,31.16z M34.529,49.653c1.93,0,3.5,1.57,3.5,3.5s-1.57,3.5-3.5,3.5s-3.5-1.57-3.5-3.5 S32.599,49.653,34.529,49.653z M49.529,23.153c0,0.767-0.354,1.479-0.937,1.946l-3.51-3.51c0.468-0.583,1.18-0.937,1.947-0.937 C48.407,20.653,49.529,21.774,49.529,23.153z M44.529,18.153c0,0.767-0.354,1.479-0.937,1.946l-3.51-3.51 c0.468-0.583,1.18-0.937,1.947-0.937C43.407,15.653,44.529,16.774,44.529,18.153z M39.529,13.153c0,0.767-0.354,1.479-0.937,1.946 l-3.51-3.51c0.468-0.583,1.18-0.937,1.947-0.937C38.407,10.653,39.529,11.774,39.529,13.153z M32.029,5.653 c1.378,0,2.5,1.121,2.5,2.5c0,0.767-0.354,1.479-0.937,1.946l-3.51-3.51C30.55,6.007,31.262,5.653,32.029,5.653z M22.755,6.364 c0.391-0.391,1.024-0.391,1.414,0c0.391,0.391,0.391,1.024,0,1.414s-1.024,0.391-1.414,0C22.365,7.388,22.365,6.755,22.755,6.364z M12.856,19.092c-0.391,0.391-1.024,0.391-1.414,0c-0.391-0.391-0.391-1.024,0-1.414c0.391-0.391,1.024-0.391,1.414,0 C13.247,18.068,13.247,18.702,12.856,19.092z M14.271,16.264l-0.707-0.707l7.071-7.071l0.707,0.707c1.134,1.133,3.109,1.133,4.243,0 l0.707-0.707l3.536,3.536c0.391,0.391,0.391,1.023,0,1.414s-1.023,0.391-1.414,0l-2.192-2.192c-1.623,1.078-3.895,1.078-5.516,0 l-4.384,4.385c1.101,1.665,1.101,3.85,0,5.515l2.192,2.192c0.391,0.391,0.391,1.023,0,1.414c-0.195,0.195-0.451,0.293-0.707,0.293 s-0.512-0.098-0.707-0.293l-3.535-3.535l0.707-0.707C15.44,19.337,15.44,17.434,14.271,16.264z M28.176,43.637 c-0.045-0.039-0.092-0.074-0.18-0.14l-8.877-8.844h2.227l12,12h-4.817v-2.717L28.176,43.637z M48.529,57.653h-6v-3.426 c0-2.206-0.954-4.189-2.464-5.574h8.464V57.653z M39.035,46.653l10.426-10.426c0.045,0.306,0.067,0.614,0.067,0.926 c0,2.055-0.948,3.947-2.602,5.191l-0.398,0.3v4.009H39.035z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var Svg3 = function Svg3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.653 59.653",
    style: {
      enableBackground: "new 0 0 59.653 59.653"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3.8c0af48c.svg";
export { ForwardRef as ReactComponent };